export const GET_ALL_DOCTOR = "GET_ALL_DOCTOR";
export const CREATE_DOCTOR = "CREATE_DOCTOR";
export const GET_ERROR = "GET_ERROR";
export const CREATEPATIENT = "CREATEPATIENT";
export const GETPATIENT = "GETPATIENT";
export const GETSPECIFICPATIENT = "GETSPECIFICPATIENT";
export const CREATEREPORT = "CREATEREPORT";
export const CREATEUSER = "CREATEUSER";
export const VERIFY_EMAIL_REQUEST = "VERIFY_EMAIL_REQUEST";
export const LOGINUSER = "LOGINUSER";
export const FORGETPASSWORD = "FORGETPASSWORD";
export const VERIFYPASSWORD = "VERIFYPASSWORD";
export const CREATE_NEW_PASSWORD = "CREATE_NEW_PASSWORD";
export const GET_MY_PATIENT = "GET_MY_PATIENT";
export const GET_SPECIFIC_REPORT = "GET_SPECIFIC_REPORT";
export const GETPPATIENTWITHREPORT = "GETPPATIENTWITHREPORT";
export const DELETMYPATIENT = "DELETMYPATIENT";
export const GETSPECIFICDOCTOR = "GETSPECIFICDOCTOR";
export const DELETEMYREPORT = "DELETEMYREPORT";
export const SENDPATIENT = "SENDPATIENT";
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const UPDATELOGGEDUSERPASSWORD = "UPDATELOGGEDUSERPASSWORD";
export const CREATE_FEEDBACK = "CREATE_FEEDBACK";
export const GET_MY_ARCHIVEDPATIENT = "GET_MY_ARCHIVEDPATIENT";
export const ARCHIVEDPATIENT = "ARCHIVEDPATIENT";
export const REPORTSTATS = "REPORTSTATS";
export const GETMYDATA = "GETMYDATA";
export const GETMYNOTIFCATION = "GETMYNOTIFCATION";
export const MARKNOTIFYASREAD = "MARKNOTIFYASREAD";
export const ACCEPT_INVITATION = "ACCEPT_INVITATION";
export const REJECT_INVITATION = "REJECT_INVITATION";
export const UPDATE_PATIENT_EMAIL = "UPDATE_PATIENT_EMAIL";
